import React from 'react'
import { StyleProp, TextStyle, ViewStyle } from 'react-native'
import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'

interface Props {
  text?: string
  children?: React.ReactNode
  textStyle?: StyleProp<TextStyle>
  containerStyle?: StyleProp<ViewStyle>
  bulletStyle?: StyleProp<TextStyle>
}

const BulletListItemContainer = styled.View`
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const BulletText = styled(Typography)`
  padding-right: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  color: ${({ theme }) => theme.colors.accent};
`

const ListItemText = styled(Typography)`
  padding-right: ${({ theme }) => theme.metrics.baseMargin}px;
  color: ${({ theme }) => theme.colors.text};
`

export const BulletListItem = ({
  children,
  text,
  textStyle,
  containerStyle,
  bulletStyle,
}: Props) => (
  <BulletListItemContainer style={containerStyle}>
    {/* This component is Typography, which is Text. So it's not raw text. */}
    {/* eslint-disable-next-line react-native/no-raw-text */}
    <BulletText style={bulletStyle}>{'•'}</BulletText>
    <ListItemText style={textStyle}>{children || text}</ListItemText>
  </BulletListItemContainer>
)

export default BulletListItem
